import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetSpinner } from '../../../../components/common/Spinner/Spinner'
import { ErrorState } from '../../../../components/common/ErrorState/ErrorState'

export type EmissionCardProps = {
    title: string
    data?: Array<{
        name: string
        value: string
        uom?: string
    }>
    isLoading: boolean
    isError: boolean
}

export const EmissionTotalCard: React.FC<EmissionCardProps> = ({
    title,
    data,
    isLoading,
    isError,
}) => {
    const { t } = useTranslation('translations')

    if (isError) {
        return (
            <div className="flex min-h-[100px] items-center justify-center">
                <ErrorState
                    className="h-full"
                    description={t('common.error_state.description')}
                    boxed={false}
                />
            </div>
        )
    }

    if (isLoading) {
        return (
            <div className="flex min-h-[100px] items-center justify-center">
                <WidgetSpinner />
            </div>
        )
    }

    return (
        <>
            <h3 className="text-heading-7 mb-2" data-testid="card-title">
                {title}
            </h3>

            <ul className="space-y-1">
                {data?.map((item, index) => (
                    <li
                        key={index}
                        className="grid grid-cols-[max-content,auto] gap-2 text-xs-tight text-subtle"
                    >
                        <span className="text-label-small w-[40px]">
                            {item.name}
                        </span>
                        <span className="text-body-medium">
                            {item.value} {item.uom}
                        </span>
                    </li>
                ))}
            </ul>
        </>
    )
}
